import { render } from "./CustomerDisplaySettings.vue?vue&type=template&id=508feb22&scoped=true&ts=true"
import script from "./CustomerDisplaySettings.vue?vue&type=script&lang=ts"
export * from "./CustomerDisplaySettings.vue?vue&type=script&lang=ts"

import "./CustomerDisplaySettings.vue?vue&type=style&index=0&id=508feb22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508feb22"]])

export default __exports__